import { Controller } from "@hotwired/stimulus"

import { parseCanonical } from "./time_picker_helpers"

// Connects to data-controller="ui--time-range-picker"
//
// Start/End tabs over two ui--time-picker-scrollable columns, matching
// @a-safe-digital/react-time-picker's TimeRangePicker. Switches the visible panel
// and binds the End picker's minimum to the current Start value (the End can't be
// before the Start), by writing the End scrollable's min-time value — which fires
// its minTimeValueChanged and re-computes the disabled options. CONEK-1580.
export default class extends Controller {
  static targets = [
    "startTab",
    "endTab",
    "startPanel",
    "endPanel",
    "startPicker",
    "endPicker",
  ]

  showStart(event) {
    event.preventDefault()
    this.activate("start")
  }

  showEnd(event) {
    event.preventDefault()
    this.activate("end")
  }

  activate(which) {
    const startActive = which === "start"
    this.startPanelTarget.classList.toggle("hidden", !startActive)
    this.endPanelTarget.classList.toggle("hidden", startActive)
    this.startTabTarget.dataset.active = String(startActive)
    this.startTabTarget.setAttribute("aria-pressed", String(startActive))
    this.endTabTarget.dataset.active = String(!startActive)
    this.endTabTarget.setAttribute("aria-pressed", String(!startActive))
  }

  // A child scrollable changed. When it's the Start picker, push its value as the
  // End picker's new minimum.
  pickerChanged(event) {
    if (!this.hasStartPickerTarget || !this.hasEndPickerTarget) return
    if (event.target !== this.startPickerTarget) return

    const parts = parseCanonical(event.detail.value)
    if (!parts) return

    this.endPickerTarget.setAttribute(
      "data-ui--time-picker-scrollable-min-time-value",
      JSON.stringify({ hour: parts.hour, minute: parts.minute }),
    )
  }
}
